import React, { Fragment, useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import ActionBar from "../ActionBar"
import {
  Button,
  IconButton,
  Input,
  Hidden,
  Menu,
  MenuItem,
  Icon,
  Typography,
  Tabs,
  Tab,
} from "@material-ui/core"
import { searchedClients, searchedClientCompanies } from "../../actions/clients"
import {
  toggleAddClientDialog,
  toggleAddClientCompanyDialog,
} from "../../actions/clients"
import DownloadIcon from "@material-ui/icons/GetApp"
import styles from "./styles"

function useDebounce(value, delay) {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value)

  useEffect(
    () => {
      // Set debouncedValue to value (passed in) after the specified delay
      const handler = setTimeout(() => {
        setDebouncedValue(value)
      }, delay)

      // Return a cleanup function that will be called every time ...
      // ... useEffect is re-called. useEffect will only be re-called ...
      // ... if value changes (see the inputs array below).
      // This is how we prevent debouncedValue from changing if value is ...
      // ... changed within the delay period. Timeout gets cleared and restarted.
      // To put it in context, if the user is typing within our app's ...
      // ... search box, we don't want the debouncedValue to update until ...
      // ... they've stopped typing for more than 500ms.
      return () => {
        clearTimeout(handler)
      }
    },
    // Only re-call effect if value changes
    // You could also add the "delay" var to inputs array if you ...
    // ... need to be able to change that dynamically.
    [value]
  )

  return debouncedValue
}

var saveData = (function() {
  var a = document.createElement("a")
  document.body.appendChild(a)
  a.style = "display: none"
  return function(data, fileName) {
    let blob = new Blob([data], { type: "text/csv" })
    let url = window.URL.createObjectURL(blob)
    a.href = url
    a.download = fileName
    a.click()
    window.URL.revokeObjectURL(url)
  }
})()

function ConvertToCSV(objArray) {
  var array = typeof objArray !== "object" ? JSON.parse(objArray) : objArray
  if (!array || !array[0]) {
    return ""
  }
  var header = Object.keys(array[0])
  var str =
    header
      .map(x => {
        return `"${typeof x === "string" ? x.replace(/"/g, "'") : x}"`
      })
      .toString() + "\r\n"

  for (var i = 0; i < array.length; i++) {
    var line = ""
    for (var index in array[i]) {
      if (line !== "") line += ","
      let x = array[i][index]
      line += `"${typeof x === "string" ? x.replace(/"/g, "'") : x}"`
    }

    str += line + "\r\n"
  }

  return str
}

export default ({
  history,
  onChange,
  changeActiveTab,
  activeFilters = [],
  sortDescending = true,
  tab = 0,
  prop,
  ...props
}) => {
  // redux
  const authenticatedUser = useSelector(
    state => state.authentication.authenticatedUser
  )
  const accessLevel = useSelector(state => state.companies.accessLevel)
  const [searchValue, setSearchValue] = useState()
  const [clientsForDownload, setClientsForDownload] = useState()
  const [searchMenuAnchorEl, setSearchMenuAnchorEl] = useState(null)
  const debouncedSearch = useDebounce(searchValue, 300)
  const dispatch = useDispatch()
  //styles
  const thisClasses = styles()

  const downloadCSV = e => {
    const csv = ConvertToCSV(clientsForDownload)
    saveData(csv, "clients.csv")
  }

  const search = e => {
    setSearchValue(e.target.value)
  }

  const updateClients = newClients => {
    prop.dispatch(searchedClients(newClients))
    setClientsForDownload(newClients)
  }

  const updateClientCompanies = newClients => {
    prop.dispatch(searchedClientCompanies(newClients))
    setClientsForDownload(newClients)
  }

  const handleOpenSearchMenu = event => {
    setSearchMenuAnchorEl(event.currentTarget)
  }
  const handleCloseSearchMenu = () => {
    setSearchMenuAnchorEl(null)
  }

  useEffect(
    () => {
      if (tab === 0) {
        if (debouncedSearch) {
          const searchResults = prop.clientList.filter(
            n =>
              (n.first_name &&
                n.first_name
                  .toLowerCase()
                  .includes(debouncedSearch.toLowerCase())) ||
              (n.last_name &&
                n.last_name
                  .toLowerCase()
                  .includes(debouncedSearch.toLowerCase())) ||
              (n.client &&
                n.client
                  .toLowerCase()
                  .includes(debouncedSearch.toLowerCase())) ||
              (n.email &&
                n.email
                  .toLowerCase()
                  .includes(debouncedSearch.toLowerCase())) ||
              (n.first_name + " " + n.last_name)
                .toLowerCase()
                .includes(debouncedSearch.toLowerCase())
          )
          if (searchResults) {
            updateClients(searchResults)
          } else {
            updateClients([{}])
          }
        } else {
          updateClients(prop.clientList)
        }
      } else {
        //companies logic
        if (debouncedSearch) {
          const searchResults = prop.companyList.filter(
            n =>
              (n.name &&
                n.name.toLowerCase().includes(debouncedSearch.toLowerCase())) ||
              (n.email &&
                n.email
                  .toLowerCase()
                  .includes(debouncedSearch.toLowerCase())) ||
              (n.name + " " + n.name)
                .toLowerCase()
                .includes(debouncedSearch.toLowerCase())
          )
          if (searchResults) {
            updateClientCompanies(searchResults)
          } else {
            updateClientCompanies([{}])
          }
        } else {
          updateClientCompanies(prop.companyList)
        }
      }
    },
    [debouncedSearch, prop.clientList, prop.companyList, tab]
  )

  return (
    <ActionBar
      buttonChildren={classes => {
        return (
          <Fragment>
            {!authenticatedUser.id && (
              <Button
                onClick={() => {
                  localStorage.clear()
                  history.push("/login")
                }}
                color="primary"
                variant="contained"
                style={{ marginRight: "8px" }}
              >
                Login / Register
              </Button>
            )}
            {accessLevel === 1 &&
              tab === 0 && (
                <Hidden smDown>
                  <Button
                    onClick={() => dispatch(toggleAddClientDialog(true))}
                    color="primary"
                    variant="contained"
                  >
                    + New Client
                  </Button>
                </Hidden>
              )}

            {accessLevel === 1 &&
              tab === 1 && (
                <Hidden smDown>
                  <Button
                    onClick={() => dispatch(toggleAddClientCompanyDialog(true))}
                    color="primary"
                    variant="contained"
                  >
                    + New Company
                  </Button>
                </Hidden>
              )}
            <Hidden mdUp>
              <Typography
                variant="p"
                style={{
                  fontSize: "1rem",
                  fontWeight: 600,
                  paddingLeft: "15px",
                }}
              >
                {tab === 0 &&
                  prop.clientList &&
                  prop.clientList.length > 0 &&
                  prop.clientList.length + " Clients"}
                {tab === 1 &&
                  prop.companyList &&
                  prop.companyList.length > 0 &&
                  prop.companyList.length + " Companies"}
              </Typography>
            </Hidden>
          </Fragment>
        )
      }}
      sortChildren={classes => {
        return (
          <Fragment>
            <div className={classes.searchWrapper}>
              <div>
                <Tabs
                  value={tab}
                  onChange={(_e, newTabVal) => changeActiveTab(newTabVal)}
                  TabIndicatorProps={{ style: { background: "primary" } }}
                  style={{ marginRight: "10px" }}
                >
                  <Tab
                    label={
                      <span
                        className={
                          tab === 0
                            ? classes.activeTab
                            : classes.customStyleOnTab
                        }
                      >
                        Clients
                      </span>
                    }
                  />
                  <Tab
                    label={
                      <span
                        className={
                          tab === 0
                            ? classes.customStyleOnTab
                            : classes.activeTab
                        }
                      >
                        Companies
                      </span>
                    }
                  />
                </Tabs>
              </div>
              <IconButton
                id="search-button"
                className={thisClasses.searchButton}
                onClick={e => downloadCSV(e)}
              >
                <DownloadIcon />
              </IconButton>

              <Hidden smDown>
                <Input
                  type="text"
                  placeholder="Search Clients"
                  fullWidth
                  name="name"
                  value={searchValue}
                  onChange={e => search(e)}
                  // onBlur={this.handleInputBlur}
                  id="name"
                  // error={!this.fieldIsValid("name")}
                  autoComplete="nope"
                  inputProps={{
                    required: true,
                  }}
                />
              </Hidden>

              <Hidden mdUp>
                <IconButton onClick={handleOpenSearchMenu}>
                  <Icon>search</Icon>
                </IconButton>
                <Menu
                  anchorEl={searchMenuAnchorEl}
                  open={Boolean(searchMenuAnchorEl)}
                  onClose={handleCloseSearchMenu}
                  getContentAnchorEl={null}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <MenuItem>
                    <Input
                      type="text"
                      placeholder="Search"
                      fullWidth
                      name="name"
                      value={searchValue}
                      onChange={e => search(e)}
                      // onBlur={this.handleInputBlur}
                      id="name"
                      // error={!this.fieldIsValid("name")}
                      autoComplete="nope"
                      inputProps={{
                        required: true,
                      }}
                    />
                  </MenuItem>
                </Menu>
              </Hidden>
            </div>
          </Fragment>
        )
      }}
    />
  )
}
